import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { get } from 'lodash';

import apiUrls from '../../../apiUrls';
import { FIELD_VALIDATION_ERROR_TYPES } from '../../../utils/constants';

import Caption from '../../Caption/Caption';
import EditLabelError from '../EditLabelError/EditLabelError';
import FileUpload from '../../FileUpload/FileUpload';
import Reinstall from '../../Reinstall/Reinstall';

import {
    EDIT_UPLOAD_MOD_COMMON_ERROR,
    EDIT_UPLOAD_MOD_FILE_FORMAT,
    EDIT_UPLOAD_MOD_FILE_SIZE,
    EDIT_UPLOAD_MOD_INVALID_FILE_SIZE_ERROR,
    EDIT_UPLOAD_MOD_INVALID_FILE_TYPE_ERROR,
    EDIT_UPLOAD_MOD_LABEL,
    EDIT_UPLOAD_MOD_NO_FILE_SELECTED,
} from './translations';

import styles from './EditUploadMod.module.css';


export default class EditUploadMod extends React.PureComponent {
    static propTypes = {
        externalError: PropTypes.oneOf([
            FIELD_VALIDATION_ERROR_TYPES.COMMON_ERROR,
            FIELD_VALIDATION_ERROR_TYPES.FILE_SIZE_ERROR,
            FIELD_VALIDATION_ERROR_TYPES.FILE_TYPE_ERROR,
            FIELD_VALIDATION_ERROR_TYPES.NO_FILE_SELECTED,
        ]),
        externalFileName: PropTypes.string,
        externalFileSize: PropTypes.number,
        isSecondary: PropTypes.bool,
        
        versions: PropTypes.arrayOf(PropTypes.shape({
            gameVersion: PropTypes.string, // .isRequired
            gameVersionId: PropTypes.number, // .isRequired
            id: PropTypes.number, // .isRequired
            modVersion: PropTypes.string, // .isRequired
            versionFile: PropTypes.string,
            versionFileOriginalName: PropTypes.string,
            versionFileSize: PropTypes.number,
        })),

        onUploadCompleted: PropTypes.func.isRequired,
        onDownloadClick: PropTypes.func,
        onFileDeleted: PropTypes.func,
    }

    constructor() {
        super()

        this.state = {
            errorType: null,
        }
    }

    componentDidMount() {
        //this.modId = document.location //.modId.toString().replace(/\/$/, '') // +this.props.match.params.modId.toString().replace(/\/$/, '')
        this.modId = Number(document.location.pathname.slice(1).split('/')[0])
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.externalError) {
            this.setState({
                errorType: nextProps.externalError,
            })
        }
    }

    handleUploadCompleted = (data, errorType) => {
        this.setState({
            errorType: errorType || null,
        })
        this.props.onUploadCompleted(get(data, '[0]', null), errorType)
    }

    renderErrorLabel() {
        const errorToMessagesMapping = {
            [FIELD_VALIDATION_ERROR_TYPES.COMMON_ERROR]: EDIT_UPLOAD_MOD_COMMON_ERROR,
            [FIELD_VALIDATION_ERROR_TYPES.FILE_SIZE_ERROR]: EDIT_UPLOAD_MOD_INVALID_FILE_SIZE_ERROR,
            [FIELD_VALIDATION_ERROR_TYPES.FILE_TYPE_ERROR]: EDIT_UPLOAD_MOD_INVALID_FILE_TYPE_ERROR,
            [FIELD_VALIDATION_ERROR_TYPES.NO_FILE_SELECTED]: EDIT_UPLOAD_MOD_NO_FILE_SELECTED,
        }
        return this.state.errorType ? (
            <EditLabelError message={errorToMessagesMapping[this.state.errorType]} />
        ) : null
    }

    handleFileDeleted = (type) => {
        return type ? this.props.onFileDeleted() : null
    }

    handleDownloadClick = () => {
        this.props.onDownloadClick(
            true, this.modId, this.props.versions[0].versionFileOriginalName, this.props.versions, true, this.props.versions[0].id
        ) // this.props.isModDownloadAccepted   number(this.props.modId)   string(this.props.title)     array(this.props.versions)    isReview    number
    }

    renderDownloadButton = () => {
        return document.location.pathname.includes('/review/') ? (
            <div className={styles.field}>
                <div className={classNames(styles.download_button, styles['db__install'])} title="Скачать">
                    <Reinstall onClick={() => {this.handleDownloadClick(1)}} />
                </div>
            </div>
        ) : null
    }

    render() {
        const isErrorFileFormat = this.state.errorType === FIELD_VALIDATION_ERROR_TYPES.FILE_TYPE_ERROR
        const isErrorFileSize = this.state.errorType === FIELD_VALIDATION_ERROR_TYPES.FILE_SIZE_ERROR

        const url = `https://tankimods.net${apiUrls.modFileUpload}` // apiUrls.modFileUpload

        return (
            <div className={styles.base}>
                <div className={styles.label}>
                    <Caption
                        isLarge={!this.props.isSecondary}
                        isRequired
                        isError={!!this.props.externalError}
                    >
                        {EDIT_UPLOAD_MOD_LABEL}
                    </Caption>
                    {this.renderErrorLabel()}
                </div>
                <div className={styles.field}>
                    <FileUpload
                        externalFileName={this.props.externalFileName}
                        externalFileSize={this.props.externalFileSize}
                        fieldName="source"
                        isError={!!this.props.externalError}
                        summary={(
                            <span>
                                <span className={styles.fileUploadSummary}>
                                    {EDIT_UPLOAD_MOD_FILE_FORMAT(isErrorFileFormat)}
                                </span>
                                <span className={styles.fileUploadSummary}>
                                    {EDIT_UPLOAD_MOD_FILE_SIZE(isErrorFileSize)}
                                </span>
                            </span>
                        )}
                        url={url}
                        onFileDeleted={this.handleFileDeleted}
                        onUploadCompleted={this.handleUploadCompleted}
                    />
                </div>
                {this.renderDownloadButton()}
            </div>
        )
    }
}
